export default __webpack_public_path__ + "static/media/avatar_tiger4.956bb07a.mp3";